import { apiRequest } from 'utils/request'
import {
  REFERENCE_PARAMETER,
  SUPPORT_PARAMETER,
  FEATURE,
  TRUCK,
  VEHICLES,
} from 'utils/constants'

const COLLECTION_URI = {
  [REFERENCE_PARAMETER]: 'reference-parameters',
  [SUPPORT_PARAMETER]: 'support-parameters',
  [FEATURE]: 'features',
  [TRUCK]: TRUCK,
  [VEHICLES]: VEHICLES,
}

export const getCollectionFilters = ({ collectionName, busFilterFlag }) => {
  if (!COLLECTION_URI[collectionName]) {
    return Promise.reject(
      new Error(`Invalid collectionName for filters: ${collectionName}`)
    )
  }
  if (collectionName === FEATURE && busFilterFlag) {
    return apiRequest({
      uri: `/${COLLECTION_URI[collectionName]}/filters?vehicleSubType=BUS`,
    })
  }

  return apiRequest({
    uri: `/${COLLECTION_URI[collectionName]}/filters`,
  })
}

export const getSearchResults = ({ uri, collectionName, requestBody }) =>
  apiRequest({
    uri: uri || `/${COLLECTION_URI[collectionName]}/search`,
    method: 'POST',
    readOnly: true,
    body: requestBody,
  })

export const getDashbuilderCollectionFilters = () =>
  apiRequest({
    uri: '/vehicles/filters',
  })

export const getSearch = ({ collectionName, queryString, method, body }) => {
  if (method === 'POST')
    return apiRequest({
      uri: `/${collectionName}/search`,
      method: 'POST',
      readOnly: true,
      body,
    })

  return apiRequest({
    uri: `/${collectionName}/search?${queryString}`,
    method: 'GET',
  })
}
